import { Typography, type SxProps } from '@mui/material';
import { motion, type MotionProps } from 'motion/react';
import { forwardRef, type ReactNode } from 'react';
import { XIcon } from '../Icons';

export type TagProps = Pick<MotionProps, 'transition' | 'layout' | 'layoutId'> & {
  text: string;
  bgColor: string;
  textColor: string;
  minWidth?: number;
  variant?: 'small' | 'large';
  endIcon?: ReactNode;
  sx?: SxProps;
  disableTextTransform?: boolean;
  isClearable?: boolean;
  onClick?: () => void;
  onClear?: () => void;
};

export const Tag = forwardRef<HTMLDivElement, TagProps>(function Tag(
  {
    text,
    bgColor,
    textColor,
    minWidth,
    variant = 'small',
    sx,
    endIcon,
    disableTextTransform = false,
    isClearable = false,
    onClear,
    ...elementProps
  }: TagProps,
  ref,
) {
  return (
    <Typography
      variant={variant === 'large' ? 'label-sm-rg' : 'label-xs-rg'}
      textTransform={disableTextTransform ? 'none' : 'capitalize'}
      color={textColor}
      ref={ref}
      component={motion.div}
      {...elementProps}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: variant === 'large' ? 16 : 'unset',
        minWidth,
        background: bgColor,
        borderRadius: 0.5,
        px: 0.5,
        width: 'fit-content',
        gap: 0.5,
        ...sx,
      }}
    >
      {text}
      {isClearable ? (
        <XIcon
          width={12}
          height={12}
          style={{ cursor: 'pointer', flexShrink: 0 }}
          onClick={(e) => {
            e.stopPropagation();
            onClear?.();
          }}
        />
      ) : (
        endIcon
      )}
    </Typography>
  );
});
